import React from 'react';
import { AddressSegments } from './segments';
import { newId } from './newid';
import { GridField } from './GridField';
import { string } from 'prop-types';

// Todo: add autocomplete to fields

const stateOptions = [
  ["ACT", 'Australian Capital Territory'],
  ["NSW", 'New South Wales'],
  ["NT", 'Northern Territory'],
  ["QLD", 'Queensland'],
  ["SA", 'South Australia'],
  ["TAS", 'Tasmania'],
  ["VIC", 'Victoria'],
  ["WA", 'Western Australia'],
];

interface Props {
  value: AddressSegments;
  name?: string;
  onChange?: (value: AddressSegments) => void;
}

interface State {
  ids: {
    street: string,
    suburb: string,
    state: string,
    postcode: string,
  }
}


export class FourPartAddress extends React.Component<Props, State> {

  state: State;

  constructor(props: Props) {
    super(props);
    this.state = {
      ids: {
        street: newId('id-street-'),
        suburb: newId('id-suburb-'),
        state: newId('id-state-'),
        postcode: newId('id-postcode-'),
      }
    }
  }

  handleChange = (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    if (this.props.onChange) {
      this.props.onChange({
        ...this.props.value,
        [event.target.name]: event.target.value,
      })
    }
  }

  getPostcodeError = () => {
    if (this.props.value.postcode.length === 0) {
      return 'This field is required'
    }
    else if (!/^\d\d\d\d$/g.test(this.props.value.postcode)) {
      return 'Must be a 4 digit postcode';
    }
  }

  render() {

    const onChange = (field: keyof AddressSegments) => (event: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
      if (this.props.onChange) {
        this.props.onChange({
          ...this.props.value,
          [field]: event.target.value,
        })
      }
    }

    const getName = (name: string) => 
      this.props.name && this.props.name.length ? `${this.props.name}-${name}`: undefined;
  
    return (
      <div>
        <div className="row address-fields" style={{}}>
          <div className="col-md-12">
            <GridField label="Street No &amp; street" value={this.props.value.street} error={this.props.value.street ? (this.props.value.street.length < 5 ? 'Must be a full street address.  Eg. 123 Example Road' : '') : "This field is required"}>
              <input 
                id={this.state.ids.street}
                value={this.props.value.street}
                onChange={onChange("street")} 
                type="text" 
                className="form-control" 
                maxLength={255} 
                name={getName('street')}
              />
            </GridField>
          </div>
        </div>
        <div className="row address-fields" style={{}}>
          <div className="col-md-12">
            <GridField label="Suburb / Town" value={this.props.value.suburb} error={this.props.value.suburb ? '' : "This field is required"}>
              <input 
                id={this.state.ids.suburb}
                value={this.props.value.suburb}
                onChange={onChange("suburb")} 
                type="text"  
                className="form-control" 
                maxLength={100} 
                name={getName('suburb')}
              />
            </GridField>
          </div>
          <div className="col-md-4">
            <GridField label="State" value={this.props.value.state} error={this.props.value.state ? '' : "This field is required"} className="grid-field-select">
              <select
                id={this.state.ids.state}
                value={this.props.value.state}
                onChange={onChange("state")} 
                className="form-control" 
                name={getName('state')}
              >
                <option value="" >-- State --</option>
                {stateOptions.map(s=> <option key={s[0]} value={s[0]}>{s[1]}</option>)}
              </select>
            </GridField>
          </div>
          <div className="col-md-2">
            <GridField label="Postcode" value={this.props.value.postcode} error={this.getPostcodeError()}            >
              <input 
                id={this.state.ids.postcode}
                value={this.props.value.postcode}
                onChange={onChange("postcode")} 
                type="text" 
                className="form-control" 
                maxLength={4}  
                pattern="[0-9]*" 
                inputMode="numeric"
                name={getName('postcode')}
              />
            </GridField>
          </div>
        </div>
      </div>
    );
  }
}